import { useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { SectionHeader } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

import { CreateQuestionTemplateModal } from './CreateQuestionTemplate'
import { QuestionTemplatesTable } from './QuestionTemplatesTable'

interface Props {
  companyId: number
}

export const QuestionTemplates = ({ companyId }: Props) => {
  const [showCreateModal, setShowCreateModal] = useState(false)

  return (
    <Box paddingY="s24" gap="s24">
      <SectionHeader
        title={i18n.t('ats.settings.templates.custom_questions.title')}
        description={i18n.t('ats.settings.templates.custom_questions.description')}
        action={{
          onClick: () => setShowCreateModal(true),
          label: i18n.t('ats.settings.templates.custom_questions.new_question.action'),
        }}
      />

      <QuestionTemplatesTable />

      {showCreateModal && (
        <CreateQuestionTemplateModal
          companyId={companyId}
          onClose={() => setShowCreateModal(false)}
        />
      )}
    </Box>
  )
}
